module.exports = __webpack_public_path__ + "img/DE00714.5373f883.png";